import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Space } from 'antd';
import Button from 'components/Button';
import InputText from 'components/InputText';
import InputSelect from 'components/InputSelect';
import DateInterval from 'components/InputDateInterval';
import * as Style from 'components/Style';
import * as S from './styles';
import {
  fetchGetTodosAssuntos,
  fetchGetTodosStatus,
  fetchSalvarLocalFiltroRequerimento,
} from 'store/fetchActions/fetchInputForm';
import { fetchGetFormulariosByFilter } from 'store/fetchActions/fetchFormulario';
import { fetchGetTodosServicos } from 'store/fetchActions/fetchServico';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import { ENUM_TIPO_PESSOA } from 'utils/consts';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { fetchBuscarSetores } from 'store/fetchActions/fetchSetores';
import { documentoMask } from 'utils/masks';
import { fetchGetAtendentesPorSetor, fetchGetTodosAtendentes } from 'store/fetchActions/fetchAtendente';
import { changeInputFilter } from 'utils/formUtils';
import moment from 'moment';
import {
  optionsTipoPessoa,
  widthCamposDefault as widthCampos,
  getFiltroInicial,
  montarSetoresAtendentes,
  montarFiltroSetores,
  validaDocumento,
} from './ListarServicoDuvida';

export default function FiltroRequerimento({ filtroInicial, salvarFiltro, handlePesquisar }) {
  const dispatch = useDispatch();

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const user = useSelector(state => state.sefaz.userProfile);
  const listaStatus = useSelector(state => state.status.todosStatus);
  const todosAssuntos = useSelector(state => state.inputs.todosAssuntos);
  const inputSelectOptionsSolicitacoes = useSelector(state => state.inputs.inputSelectOptionsSolicitacoes);
  const configFiltroSalvo = useSelector(state => state.formulario.configFiltroPesquisa);

  const [isClearDataAbertura, setIsClearDataAbertura] = useState(false);
  const [isClearDataEncerramento, setIsClearDataEncerramento] = useState(false);
  const [optionsAtendentes, setOptionsAtendentes] = useState([]);
  const [optionsAssuntos, setOptionsAssuntos] = useState([]);
  const [optionsSetor, setOptionsSetor] = useState([]);
  const [optionsSolicitacao, setOptionsSolicitacao] = useState([]);
  const [setoresSelecionados, setSetoresSelecionados] = useState([]);

  const {
    watch,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: getFiltroInicial(filtroInicial),
  });

  const buscaSetoresAtendentes = () => {
    dispatch(fetchBuscarSetores()).then(resposta => {
      setOptionsSetor(montarSetoresAtendentes(resposta));
    });

    dispatch(fetchGetTodosAtendentes()).then(resposta => {
      setOptionsAtendentes(montarDadosInputSelect(resposta, 'id', 'nome'));
    });
  };

  const tipoDocumentoNome = watch('tipoPessoaId') === ENUM_TIPO_PESSOA.fisica.id ? 'CPF' : 'CNPJ';

  const ObterAtendentePorSetor = setores => {
    const filtros = montarFiltroSetores(setores);
    dispatch(fetchGetAtendentesPorSetor(filtros)).then(resposta => {
      setOptionsAtendentes(montarDadosInputSelect(resposta, 'id', 'nome'));
    });
  };

  React.useEffect(() => {
    if (unitaryTests) return;
    if (user && user?.profile !== ENUM_TIPO_PERFIL.ATENDENTE) {
      dispatch(fetchBuscarSetores(user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR)).then(resposta => {
        const todosSetores = resposta?.map(setor => {
          return setor.id !== 0
            ? {
                value: setor?.id,
                label: setor?.nome,
                atendentes: setor?.atendentes,
              }
            : null;
        });
        setOptionsSetor(todosSetores);
      });

      dispatch(fetchGetTodosAtendentes()).then(resposta => {
        setOptionsAtendentes(montarDadosInputSelect(resposta, 'id', 'nome'));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user, unitaryTests]);

  React.useEffect(() => {
    if (unitaryTests) return;
    dispatch(fetchGetTodosAssuntos(todosAssuntos)).then(resposta => {
      setOptionsAssuntos(montarDadosInputSelect(resposta, 'id', 'descricao'));
    });
    dispatch(fetchGetTodosStatus(listaStatus));
    dispatch(fetchGetTodosServicos(inputSelectOptionsSolicitacoes)).then(resposta => {
      setOptionsSolicitacao(montarDadosInputSelect(resposta, 'id', 'nome'));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, unitaryTests]);

  const handleChange = e => {
    changeInputFilter(e, setValue);
  };

  const onSubmit = data => {
    if (validaDocumento(data?.numeroDocumento, data?.tipoPessoaId)) return;
    handlePesquisar(data);
  };

  const limparFiltro = () => {
    setIsClearDataEncerramento(true);
    setIsClearDataAbertura(true);
    setValue('dataAbertura', '');
    setValue('dataEncerramento', '');
    setValue('protocolo', '');
    setValue('atendenteId', '');
    setValue('assuntoId', '');
    setValue('statusId', '');
    setValue('tipoPessoaId', '');
    setValue('solicitacaoId', '');
    setValue('numeroDocumento', '');
    setValue('setorId', []);
    dispatch(fetchGetFormulariosByFilter({}, 1, 10));
    dispatch(fetchGetTodosAtendentes()).then(resposta => {
      setOptionsAtendentes(montarDadosInputSelect(resposta, 'id', 'nome'));
    });
    salvarFiltro({});
    dispatch(fetchSalvarLocalFiltroRequerimento(null, 1, 10));
    setSetoresSelecionados([]);
  };

  const onSelect = value => {
    setSetoresSelecionados([...setoresSelecionados, value]);
    ObterAtendentePorSetor([...setoresSelecionados, value]);
  };

  const onDeselect = value => {
    const index = setoresSelecionados.indexOf(value);
    if (index > -1) {
      setoresSelecionados.splice(index, 1);
    }
    if (setoresSelecionados.length === 0) {
      buscaSetoresAtendentes();
    } else {
      setSetoresSelecionados([...setoresSelecionados]);
      ObterAtendentePorSetor([...setoresSelecionados]);
    }
  };

  const filterArray = values => {
    return values.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));
  };

  const limparSetor = () => {
    setSetoresSelecionados([]);
    buscaSetoresAtendentes();
  };

  const onChangeTipoDocumento = e => {
    if (!e) return;
    setValue('tipoPessoaId', e);
    setValue('numeroDocumento', '');
  };

  const onClearTipoPessoa = () => {
    setValue('tipoPessoaId', '');
    setValue('numeroDocumento', '');
  };

  return (
    <form>
      <Style.GlobalCard>
        <Row>
          <Col xs={widthCampos.xs} sm={widthCampos.sm} md={widthCampos.md} lg={widthCampos.lg} xl={widthCampos.xl3}>
            <DateInterval
              label="Data de Abertura"
              name="dataAbertura"
              defaultValue={
                configFiltroSalvo?.filtro?.dataAbertura?.dataInicio
                  ? [
                      moment(configFiltroSalvo?.filtro?.dataAbertura?.dataInicio),
                      moment(configFiltroSalvo?.filtro?.dataAbertura?.dataFim),
                    ]
                  : null
              }
              control={control}
              onChange={handleChange}
              isClear={isClearDataAbertura}
              openChange={() => setIsClearDataAbertura(false)}
            />
          </Col>
          <Col xs={widthCampos.xs} sm={widthCampos.sm} md={widthCampos.md} lg={widthCampos.lg} xl={widthCampos.xl3}>
            <DateInterval
              label="Data do Encerramento"
              name="dataEncerramento"
              control={control}
              onChange={handleChange}
              isClear={isClearDataEncerramento}
              openChange={() => setIsClearDataEncerramento(false)}
            />
          </Col>
          <Col xs={widthCampos.xs} sm={widthCampos.sm} md={widthCampos.md} lg={widthCampos.lg} xl={widthCampos.xl3}>
            <InputText
              label="Protocolo"
              name="protocolo"
              placeholder={'Protocolo'}
              control={control}
              onChange={handleChange}
              maxLength={14}
              errors={errors}
            />
          </Col>
          <Col xs={widthCampos.xs} sm={widthCampos.sm} md={widthCampos.md} lg={widthCampos.lg} xl={widthCampos.xl3}>
            <InputSelect
              label="Assunto"
              name="assuntoId"
              placeholder={'Assunto'}
              control={control}
              options={optionsAssuntos}
            />
          </Col>
          <Col xs={widthCampos.xs} sm={widthCampos.sm} md={widthCampos.md} lg={widthCampos.lg} xl={widthCampos.xl4}>
            <InputSelect
              label="Status"
              name="statusId"
              placeholder={'Status'}
              control={control}
              options={montarDadosInputSelect(listaStatus, 'id', 'descricao')}
            />
          </Col>
          <Col xs={widthCampos.xs} sm={widthCampos.sm} md={widthCampos.md} lg={widthCampos.lg} xl={widthCampos.lg}>
            <InputSelect
              label="Serviço"
              name="solicitacaoId"
              placeholder={'Serviço'}
              control={control}
              options={optionsSolicitacao}
            />
          </Col>
          <Col xs={widthCampos.xs} sm={widthCampos.sm} md={widthCampos.md} lg={widthCampos.lg} xl={widthCampos.xl3}>
            <InputSelect
              label="Tipo de Pessoa"
              name="tipoPessoaId"
              placeholder={'Tipo de Pessoa'}
              control={control}
              onChange={e => onChangeTipoDocumento(e)}
              onClear={onClearTipoPessoa}
              options={optionsTipoPessoa}
            />
          </Col>
          {watch('tipoPessoaId') && (
            <Col xs={widthCampos.xs} sm={widthCampos.sm} md={widthCampos.md} lg={widthCampos.lg} xl={widthCampos.xl3}>
              <InputText
                label={tipoDocumentoNome}
                name="numeroDocumento"
                placeholder={tipoDocumentoNome}
                control={control}
                onChange={e =>
                  handleChange({
                    target: {
                      name: 'numeroDocumento',
                      value: documentoMask(e.target.value),
                    },
                  })
                }
                maxLength={tipoDocumentoNome === 'CPF' ? 14 : 18}
                errors={errors}
              />
            </Col>
          )}
          {user?.profile !== ENUM_TIPO_PERFIL.ATENDENTE && (
            <>
              <Col xs={widthCampos.xs} sm={widthCampos.sm} md={widthCampos.md} lg={widthCampos.lg} xl={widthCampos.xl4}>
                <InputSelect
                  label="Setor"
                  name="setorId"
                  placeholder={'Setor'}
                  control={control}
                  viewChange={onSelect}
                  onDeselect={onDeselect}
                  options={optionsSetor}
                  mode={'multiple'}
                  onClear={() => limparSetor()}
                />
              </Col>
              <Col xs={widthCampos.xs} sm={widthCampos.sm} md={widthCampos.md} lg={widthCampos.lg} xl={widthCampos.xl4}>
                <InputSelect
                  label="Atendente"
                  name="atendenteId"
                  placeholder={'Atendente'}
                  control={control}
                  options={filterArray(optionsAtendentes)}
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={5}>
            <S.ContainButton>
              <Space>
                <Button text={'Pesquisar'} clickAction={handleSubmit(onSubmit)} />
                <Button text={'Limpar Filtro'} clickAction={() => limparFiltro()} />
              </Space>
            </S.ContainButton>
          </Col>
        </Row>
      </Style.GlobalCard>
    </form>
  );
}
